import React from 'react';
import EmailAddresses from '../../../libs/react-components-admin/email/email-addresses';

class Support extends React.Component {

  constructor(props) {
    super(props);
    let model = props.model;
    if (!model) {
      model = {};
      props.onChange(model);
    }
    this.state = {
      model: model,
    };
  }

  updateModel(fieldName, value) {
    this.setState(
      prevState => {
        const model = {...prevState.model};
        model[fieldName] = value;
        return {model: model};
      },
      () => this.props.onChange(this.state.model)
    )
  }

  render() {
    return <div>
      <label>Support email addresses</label>
      <div className="form-text mb-2">An alert will be sent to these email addresses if a problem happens (e.g. if the customer&apos;s email is already taken)</div>
      <div className="row justify-content-center">
        <div className="col-12 col-md-8">
          <EmailAddresses minEmailAddresses={1}
                          initialModel={this.state.model.emailAddresses}
                          onChange={v => this.updateModel('emailAddresses', v)}/>
        </div>
      </div>
    </div>;
  }

}
export default Support;